import { createError404Link } from "@/router";
import { catch401 } from "@/services/apiClient/helpers";
import { CategoryApi } from "@/services/collection/categories";
import { CatalogueFilter } from "@/services/collectibles/collectiblesFilter";
import { useCatalogueFilterStore } from "@/store";
import { useRoute, useRouter } from "vue-router";

export function useCatalogueItemsListFilter() {
  const route = useRoute();
  const router = useRouter();

  const currentCategorySlug = route.params.categoryUrl as string;

  const filter = ref<CatalogueFilter>();

  CategoryApi.fetchByUrl(currentCategorySlug)
    .then(async (category) => {
      if (category === undefined) {
        router.push(createError404Link());
      } else {
        const savedFilter = useCatalogueFilterStore().getForCategory(category);
        if (savedFilter) {
          filter.value = savedFilter;
        } else {
          const f = new CatalogueFilter(category);
          await f.init();
          filter.value = f;
        }
      }
    })
    .catch(catch401);

  return {
    filter,
  };
}
